import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filterType: {
    startDate: "",
    endDate: "",
    voucherCode: "",
  },
  keyword: "",
  page: 1,
  limit: 10,
};

const saleReturnSlice = createSlice({
  name: "saleReturn",
  initialState,
  reducers: {
    setFilterType: (state, action) => {
      state.filterType = {
        ...state.filterType,
        ...action.payload,
      };
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setLimit: (state, action) => {
      state.limit = action.payload;
    },
    setSearch: (state, action) => {
      state.keyword = action.payload;
    },
    clearFilter: (state) => {
      state.filterType = {
        startDate: "",
        endDate: "",
        voucherCode: "",
      };
      state.keyword = "";
      state.page = 1;
      state.limit = 10;
    },
  },
});

export const { setPage, setLimit, setFilterType, clearFilter, setSearch } =
  saleReturnSlice.actions;
export default saleReturnSlice.reducer;
